module.exports = __webpack_public_path__ + "img/logo.6ea0ae0d.png";